export default "__VITE_ASSET__628cbb45__"